import Vue from 'vue'
import App from './App.vue'

// VueRouter
import VueRouter from 'vue-router'
import { routes } from './routes.js'
Vue.use(VueRouter);
const router = new VueRouter({
	routes,
	mode: 'history',
});

// Buefy
import { Field, Autocomplete, Loading } from 'buefy'
import 'buefy/dist/buefy.css'
Vue.use(Field)
Vue.use(Autocomplete)
Vue.use(Loading)

// import styles
import "@/styles/site.scss";

// vuex
import { store } from './store/store';

// my app
Vue.config.productionTip = false
new Vue({
  render: h => h(App),
  store,
  router,
}).$mount('#app')
